// CandidateLifecycle.jsx
import React, { useState, useEffect } from "react";

const CandidateLifecycle = () => {
  // ADD THIS TEMPORARILY
  useEffect(() => {
    alert("CANDIDATE LIFECYCLE LOADED!");
  }, []);

  return (
    <div style={{ background: 'white', padding: '100px' }}>
       <h1>RECRUITMENT PAGE</h1>
    </div>
  );
};
export default CandidateLifecycle;